function SearchBar({ onSearch }) {
  return (
    <input
      type="text"
      placeholder="Search emails"
      onChange={(e) => onSearch(e.target.value)}
      style={{ width: "100%", padding: "10px", fontSize: "16px" }}
    />
  );
}

export default SearchBar;